import { useCallback, useEffect } from "react";
import { empresaLogin } from "../api/empresaApi";
import type { EmpresaSessionResponse } from "../api/empresaApi";
import { getEmpresaToken, getEmpresaUser } from "../api/empresaApi";
import { useEmpresaStore } from "../../store/useEmpresaStore";

export function useEmpresaSession() {
  const token = useEmpresaStore((s) => s.token);
  const user = useEmpresaStore((s) => s.user);
  const setSession = useEmpresaStore((s) => s.setSession);
  const clearSession = useEmpresaStore((s) => s.clearSession);
  const hydrateFromStorage = useEmpresaStore((s) => s.hydrateFromStorage);

  useEffect(() => {
    hydrateFromStorage();
  }, [hydrateFromStorage]);

  const loginEmpresa = useCallback(
    async (usuario: string, senha: string): Promise<EmpresaSessionResponse> => {
      const data = await empresaLogin(usuario, senha);
      if (!data) throw new Error("Login falhou.");
      setSession(data);
      return data;
    },
    [setSession],
  );

  const logoutEmpresa = useCallback(() => {
    clearSession();
  }, [clearSession]);

  const tokenFromStorage = getEmpresaToken();
  const userFromStorage = getEmpresaUser();
  const fromStorage = !!(tokenFromStorage && userFromStorage);
  const isEmpresaLoggedIn = !!(token && user) || fromStorage;

  console.log("[useEmpresaSession]", {
    hasToken: !!token,
    hasUser: !!user,
    hasTokenStorage: !!tokenFromStorage,
    hasUserStorage: !!userFromStorage,
    fromStorage,
    isEmpresaLoggedIn,
  });

  return {
    loginEmpresa,
    logoutEmpresa,
    isEmpresaLoggedIn,
    empresaUser: user ?? getEmpresaUser() ?? null,
    getEmpresaToken: () => getEmpresaToken(),
  };
}
